export enum HandleScriptType {
  Add = 1,
  Remove = 2
}
